import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const CopyIcon = withSvgIcon(
    <g>
        <path d="M319,12h-11.9H282H125v50H75v426h300v-50h50V156.7v-25.1V126L319,12z M307.1,38h0.6l87.1,93.7h-87.7V38zM349,462H101V88h24v350h224V462z M399,412H151V38h131v118.7h117V412z" />
    </g>
);
